module.exports = __webpack_public_path__ + "static/img/pic002.a25f33f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pic002.png
// module id = gsQu
// module chunks = 1